exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".tags-view-wrapper .tags-view-item .el-icon-close[data-v-fac8ca64]{width:16px;height:16px;vertical-align:2px;border-radius:50%;text-align:center;-webkit-transition:all .3s cubic-bezier(0.645, 0.045, 0.355, 1);transition:all .3s cubic-bezier(0.645, 0.045, 0.355, 1);-webkit-transform-origin:100% 50%;transform-origin:100% 50%}.tags-view-wrapper .tags-view-item .el-icon-close[data-v-fac8ca64]:before{-webkit-transform:scale(0.6);transform:scale(0.6);display:inline-block;vertical-align:-3px}.tags-view-wrapper .tags-view-item .el-icon-close[data-v-fac8ca64]:hover{background-color:#b4bccc;color:#fff}", ""]);

// exports
